import { gql, TypedDocumentNode } from '@common/hooks';
import { StaffingRequestType } from '@applicant-flow/types';

export type PaginatedStaffingRequestsListQueryVariables = {
  limit: number;
  offset: number;
  orderDirection?: string;
  orderField?: string;
  filters?: Record<string, string[] | null>;
  staffingRequestTypes: string[];
};

export type PaginatedStaffingRequestsListQueryResponse = {
  paginatedStaffingRequests: {
    staffingRequests: StaffingRequestType[];
    totalCount: number;
  };
};

export const PaginatedStaffingRequestsList: TypedDocumentNode<
  PaginatedStaffingRequestsListQueryResponse,
  PaginatedStaffingRequestsListQueryVariables
> = gql`
  query PaginatedStaffingRequestsList(
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection
    $orderField: StaffingRequestOrderField
    $filters: StaffingRequestFilterInput
    $staffingRequestTypes: [StaffingRequestType!]
  ) {
    paginatedStaffingRequests(
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
      filters: $filters
      staffingRequestTypes: $staffingRequestTypes
    ) {
      staffingRequests {
        id
        name
        shiftsPerWeek
        hiringLeader {
          id
          name
        }
        hoursPerShift
        shiftType
        startDate
        length
        state
        stateChangedAt
        submissionsPaused
        externalId
        billingRegularRate
        highestRate
        lowestRate
        rateUpdatedAt
        staffingRequestPositionsCount
        openStaffingRequestPositionsCount
        code
        staffingRequestType
        acceptedStaffingRequestApplicationsCount
        staffingRequestApplicationsCount
        submittedStaffingRequestApplicationsCount
        inReviewStaffingRequestApplicationsCount
        offeredOffersStaffingRequestApplicationsCount
        canOpenUp {
          value
        }
        canHold {
          value
        }
        canCancel {
          value
        }
        canUpdate {
          value
        }

        organization {
          id
          name
        }

        organizationUnit {
          id
          name
          costCenter
          clinicalUnit {
            id
            displayName
          }

          department {
            id
            name

            organizationBusiness {
              id
              name
              city
              stateCode
            }
          }
        }

        role {
          id
          abbreviation
        }
      }

      totalCount
    }
  }
`;
